import { useLocation } from 'react-router-dom';
import { getActiveMenuPath } from '~/lib/menu';

/**
 * The menu path to highlight for the current location — the longest menu path that equals or
 * prefixes the current pathname (so only the most specific matching item is active). Backed by
 * the pure {@link getActiveMenuPath} for use outside the component lifecycle.
 */
export function useActiveMenuPath(): string | undefined {
	const { pathname } = useLocation();
	return getActiveMenuPath(pathname);
}
